var _path, _path2, _path3, _path4, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSmartwatch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.75,10A.7502.7502,0,0,0,50,9.25H30a.7502.7502,0,0,0-.75.75v9.25H28A8.76,8.76,0,0,0,19.25,28V52A8.76,8.76,0,0,0,28,60.75h1.25V70a.7502.7502,0,0,0,.75.75H50a.7502.7502,0,0,0,.75-.75V60.75H52A8.76,8.76,0,0,0,60.75,52V44.75H64a.7502.7502,0,0,0,.75-.75V36a.7502.7502,0,0,0-.75-.75H60.75V28A8.76,8.76,0,0,0,52,19.25H50.75V10Zm10,26.75h2.5v6.5h-2.5Zm-30-26h18.5v2.5H30.75Zm0,4h18.5v4.5H30.75Zm18.5,54.5H30.75v-2.5h18.5Zm0-4H30.75v-4.5h18.5ZM52,20.75A7.25834,7.25834,0,0,1,59.25,28V52A7.25834,7.25834,0,0,1,52,59.25H28A7.25834,7.25834,0,0,1,20.75,52V28A7.25834,7.25834,0,0,1,28,20.75H52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.36914,36.8252l1.06055,1.06054a10.706,10.706,0,0,1,15.14062,0l1.06055-1.06054a12.20544,12.20544,0,0,0-17.26172,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.06934,39.52539l1.06054,1.06055a6.88782,6.88782,0,0,1,9.74024,0l1.06054-1.06055a8.38727,8.38727,0,0,0-11.86132,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.76953,42.22559l1.06055,1.06054a3.14267,3.14267,0,0,1,4.33984,0l1.06055-1.06054a4.56791,4.56791,0,0,0-6.46094,0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 46,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSmartwatch);
export default __webpack_public_path__ + "static/media/icon_smartwatch.a187cdffd79fb1d584882078aa410a66.svg";
export { ForwardRef as ReactComponent };